import PropTypes from "prop-types";
import React from "react";
import truncateName from "../../utils/Functions/shortenStr";
import moment from "moment";

export const ApiHistoryTable = ({ api, index, state, showMoreData }) => {
  const parseJson = require("parse-json");

  const requestData =
    api && api.request_body && parseJson(JSON.stringify(api.request_body));

  const responseData =
    api && api.response_body && parseJson(JSON.stringify(api.response_body));

  return (
    <div className="api-history-table-wrap" key={index}>
      <div
        onClick={() => showMoreData(api.id)}
        data-testid="showMoreData"
        className="api-history-table-data"
      >
        <div className="api-history-table-data-payment">
          {api.product_type} Test
        </div>
        <div className="api-history-table-data-url">
          {truncateName(api.url, 30) || "-"}
        </div>
        <div className="api-history-table-data-request">
          {api.method} Request
        </div>
        <div className="api-history-table-data-status">
          <span
            className={api.response_status_code === "200" ? "dot" : "dot fail"}
          ></span>
          <span>
            {api.response_status_code === "200" ? "Successful" : "Unsuccessful"}
          </span>
        </div>
        <div className="api-history-table-data-time">
          {moment(api.created_at).format("YYYY-MM-DD") || "-"}
        </div>
      </div>
      {state.showMore && state.index === api.id ? (
        <div className="drop-box">
          <div className="drop-box-left">
            <div className="drop-box-request drop-box-button ">REQUEST</div>
            {requestData}
          </div>
          <div className="drop-box-right">
            <div className="drop-box-response drop-box-button ">RESPONSE</div>
            {responseData}
          </div>
        </div>
      ) : (
        ""
      )}
    </div>
  );
};

ApiHistoryTable.propTypes = {
  api: PropTypes.shape({
    created_at: PropTypes.any,
    id: PropTypes.number,
    method: PropTypes.any,
    product_type: PropTypes.any,
    request_body: PropTypes.any,
    response_body: PropTypes.any,
    response_status_code: PropTypes.string,
    url: PropTypes.any,
  }),
  index: PropTypes.any,
  showMoreData: PropTypes.func,
  state: PropTypes.shape({
    index: PropTypes.any,
    showMore: PropTypes.any,
  }),
};
